import { hasAnyPermissions } from '../utils';

export default {
    name: 'userProductivityReportPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'userProductivityReport';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                // to remove in 32.x.x
                permissions: {
                    withUserLink: hasAnyPermissions('users.show'),
                },
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
